import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/classificados',
		component: Base,
		children: [
			{
				path: '',
				name: 'ClassificadosList',
				component: List,
				meta: {
					path: '/sistema/classificados',
					pai: 'Sistema',
					title: 'Admin - Classificados',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Classificados',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'ClassificadosNovo',
				component: Form,
				meta: {
					path: '/sistema/classificados',
					pai: 'Sistema',
					title: 'Admin - Classificados - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Classificados',
						class: '',
						active: false,
						url: '/sistema/classificados'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'ClassificadosEditar',
				component: Form,
				meta: {
					path: '/sistema/classificados',
					pai: 'Sistema',
					title: 'Admin - Classificados - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Classificados',
						class: '',
						active: false,
						url: '/sistema/classificados'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]